import { logger } from './logger'

export const isTestingModeEnabled = (): boolean => {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const testingParam = urlParams.get('testing')

    const isTesting = testingParam === 'true'

    if (isTesting && import.meta.env.VITE_NETWORK_ENV !== 'PROD') {
      logger.info('Testing mode enabled - HKD and PHP routes unlocked')
    }

    return isTesting
  } catch (error) {
    logger.error('Failed to check testing mode', error)
    return false
  }
}
